export const AUTH_CONTEXT_INITIAL_STATE = {
  session: null,
  user: null,
  profile: null,
  isLoading: true,
  isAuthenticated: false,
  error: null,
  success: null,
  severity: 'info' as const,
  signOut: async () => {},
  signIn: async () => ({ error: null }),
  signUp: async () => ({ error: null }),
  updateProfile: async () => ({ error: null }),
  refreshSession: async () => {},
  resetPassword: async () => ({ error: null }),
  updatePassword: async () => ({ error: null }),
}
